import styles from './index.module.scss'
import { Button, message } from 'antd';
import ResolutionSelection from '@view/compoents/ResolutionSelection/ResolutionSelection';
import { useState, useRef, useContext, useEffect, forwardRef, useImperativeHandle, useMemo } from 'react';
import { ImageResizeContext } from '../imageResizeContext'
import { debounce } from 'lodash';
import { doSrResize } from '@utils/workflowOfBuildEdit'
import Utils from '@utils/utils';
import Iconfont from '@utils/Iconfont';
import { IMAGE_TYPE } from '@utils/CONST'

const defaultSize = [{
    key: '2times',
    text: '放大2倍',
    icon: 'icon-a2xOutlined',
    targetSize: 2
}, {
    key: '4times',
    text: '放大4倍',
    icon: 'icon-a4xOutlined',
    targetSize: 4
}]
const recommendSize = [{
    key: '1',
    normalIcon: require('@assets/images/imageResize/suggest1.png'),
    text: '主图1:1',
    tips: '1440*1440',
    targetSize: [1440, 1440]
}, {
    key: '2',
    normalIcon: require('@assets/images/imageResize/suggest2.png'),
    text: '主图3:4',
    tips: '1440*1920',
    targetSize: [1920, 1440]
}, {
    key: '3',
    normalIcon: require('@assets/images/imageResize/suggest3.png'),
    text: '电商主图',
    tips: '800*800',
    targetSize: [800, 800]
}, {
    key: '4',
    normalIcon: require('@assets/images/imageResize/suggest4.png'),
    text: '移动端海报',
    tips: '1200*1920',
    targetSize: [1920, 1200]
}, {
    key: '5',
    normalIcon: require('@assets/images/imageResize/suggest5.png'),
    text: 'Amazon',
    tips: '1600*1600',
    targetSize: [1600, 1600]
}, {
    key: '6',
    normalIcon: require('@assets/images/imageResize/suggest6.png'),
    text: 'Alibaba',
    tips: '1000*1000',
    targetSize: [1000, 1000]
}, {
    key: '7',
    normalIcon: require('@assets/images/imageResize/suggest7.png'),
    text: 'SHEIN 1:1',
    tips: '1200*1200',
    targetSize: [1200, 1200]
}, {
    key: '8',
    normalIcon: require('@assets/images/imageResize/suggest8.png'),
    text: 'SHEIN 3:4',
    tips: '1340*1785',
    targetSize: [1785, 1340]
}, {
    key: '9',
    normalIcon: require('@assets/images/imageResize/suggest9.png'),
    text: 'Shopify',
    tips: '2048*2048',
    targetSize: [2048, 2048]
}, {
    key: '10',
    normalIcon: require('@assets/images/imageResize/suggest10.png'),
    text: '小红书配图',
    tips: '1242*1660',
    targetSize: [1660, 1242]
}, {
    key: '11',
    normalIcon: require('@assets/images/imageResize/suggest11.png'),
    text: '一寸照',
    tips: '295*413px',
    targetSize: [413, 295]
}, {
    key: '12',
    normalIcon: require('@assets/images/imageResize/suggest12.png'),
    text: '二寸照',
    tips: '413*579px',
    targetSize: [579, 413]
}]

const showType = [{
    key: 1,
    icon: 'icon-fillOutlined',
    text: '裁切展示'
}, {
    key: 0,
    icon: 'icon-fullOutlined',
    text: '完整展示'
}]

const ResizePageLeft = forwardRef((props, ref) => {
    const resolutionRef = useRef()
    const [resolutionDisabled, setResolutionDisabled] = useState(false)
    const isMounted = useRef(true)
    const {
        showCropType,
        setShowCropType,
        setZoom,
        setInitMinZoom,
        setInitLeftCanvasZoom,
        setInitRightCanvasZoom,
        handleLoading, setHandleLoading,
        resizeResult, setResizeResult,
        imageUrl, imgWidth, imgHeight,
        targetSsize, setTargetSize,
        selectedKey, setSelectedKey,
        initImgRatio, setInitImgRatio,
        setTargetSizeCache, targetSizeCache,
        setSelectedKeyCache, saveResultToProject,
        AIEditTemprojectId, setAIEditTempProjectId,
        AIEditTemTaskId, setAIEditTempTaskId
    } = useContext(ImageResizeContext)
    useImperativeHandle(ref, () => ({
        resetResolution: () => resolutionRef.current.customSize(1024, 1024)
    }))

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const hasMounted = useRef(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            hasMounted.current = true;
        }, 50);
        return () => clearTimeout(timer);
    }, []);

    const onCanvasChange = (w, h, ratio) => {
        if (!hasMounted.current) return
        setSelectedKey()
        setTargetSize([h, w])
        setInitImgRatio(ratio)
    }

    const DeaultSize = (
        <div className={styles.selectBox}>
            {
                defaultSize.map((item) => {
                    return <div key={item.key}
                        className={`${styles.selectItem} ${selectedKey == item.key && styles.selectItemActive}`}
                        onClick={() => selectClick(item.key, item.targetSize)}>
                        <div className={styles.selectItemBottom}><Iconfont type={item.icon} className={styles.Icon} />
                            {item.text}</div>
                    </div>
                })
            }
            <div style={{ width: '88px' }}></div>
        </div>
    )

    const RecommendSize = (
        <div className={styles.selectBox}>
            {
                recommendSize.map((item) => {
                    return <div key={item.key}
                        className={`${styles.selectItem} ${selectedKey == item.key && styles.selectItemActive}`}
                        onClick={() => selectClick(item.key, item.targetSize)}>
                        <div className={styles.selectItemTop}><img src={item.normalIcon} alt="" /></div>
                        <div className={styles.selectItemBottom}><p>{item.text}</p><p>{item.tips}</p></div>
                    </div>
                })
            }
        </div>
    )

    const ShowType = (
        <div className={styles.selectBox}>
            {
                showType.map((item) => {
                    return <div key={item.key}
                        className={`${styles.selectItem} ${showCropType == item.key && styles.selectItemActive}`}
                        onClick={() => showTypeClick(item.key)}>
                        <div className={styles.selectItemBottom}>
                            <Iconfont type={item.icon} className={styles.Icon} />{item.text}</div>
                    </div>
                })
            }
            <div style={{ width: '88px' }}></div>
        </div>
    )

    const showTypeClick = (key) => {
        setInitLeftCanvasZoom()
        setInitRightCanvasZoom()
        setZoom()
        setInitMinZoom()
        setShowCropType(key)
    }

    const selectClick = (key, targetSize) => {
        setSelectedKey(key)
        if (typeof targetSize == 'number') {
            setTargetSize([targetSize * Number(imgHeight), targetSize * Number(imgWidth)])
        } else {
            setTargetSize(targetSize)
        }
    }

    useEffect(() => {
        if (!selectedKey) return
        setSelectedKey(selectedKey)
    }, [selectedKey])

    const hasRunRef = useRef(false);
    useEffect(() => {
        if (!hasRunRef.current && targetSizeCache.length > 0) {
            hasRunRef.current = true;
            resolutionRef.current.customSize(targetSizeCache[1], targetSizeCache[0])
        }
    }, [targetSizeCache]);


    const handClick = debounce(async () => {
        if (handleLoading) return
        if (targetSsize.length == 0) { message.warning('请选择要修改的尺寸！'); return }
        setHandleLoading(true);
        // setTargetSizeCache([...targetSsize])
        setSelectedKeyCache(selectedKey)
        const res = await doSrResize(imageUrl, targetSsize, () => !isMounted.current)
        if (!res) {
            setHandleLoading(false);
            return
        }
        // 保存结果到项目
        const res2 = await saveResultToProject(res.output[0], res.output?.[1], AIEditTemprojectId, IMAGE_TYPE.IMAGE_RESIZE)
        if (!res2) return
        const projectId = res2.id
        const taskId = res2.taskList?.[0]
        setAIEditTempProjectId(projectId)
        setAIEditTempTaskId(taskId)

        setInitMinZoom()
        setInitLeftCanvasZoom()
        setInitRightCanvasZoom()

        if (res.output?.length > 0 && (targetSsize[0] > 8192 || targetSsize[1] > 8192)) {
            const { width, height } = await Utils.getImageDimensions(res.output[0])
            setTargetSizeCache([height, width])
        } else {
            setTargetSizeCache([...targetSsize])
        }

        setResizeResult([...res.output]);
        setHandleLoading(false)
        removeQueryParams()
    }, 300);

    const removeQueryParams = () => {
        const currentUrl = window.location.href;
        const newUrl = currentUrl.split('?')[0];
        window.history.pushState({}, document.title, newUrl)
    };

    const showSelectShowType = useMemo(() => {
        if (targetSsize.length == 0) return true
        if (imageUrl && targetSsize[1] / targetSsize[0] != imgWidth / imgHeight) {
            return true
        }
    }, [targetSsize, imgWidth, imgHeight, imageUrl])

    return <div className={styles.resizePageLeft}>
        <div className={`${styles.leftTop} ${!imageUrl && 'disabled'}`} >
            <p className={styles.title}>图像尺寸</p>
            <ResolutionSelection
                ref={resolutionRef}
                disabled={resolutionDisabled}
                initImgRatio={initImgRatio || '1:1'}
                initImgWidth={1024}
                initImgHeight={1024}
                onChange={onCanvasChange}
                maxWidth={8192}
                maxHeight={8192}
                minWidth={64}
                minHeight={64}
                showTips={true}
            />
            <p className={styles.title} style={{ marginTop: '24px' }}>倍数放大</p>
            {DeaultSize}
            <p className={styles.smalltitle}>最多放大至8192*8192Px</p>
            <p className={styles.title} style={{ marginTop: '10px' }}>推荐尺寸</p>
            {RecommendSize}
            {
                showSelectShowType && <>
                    <p className={styles.title} style={{ marginTop: '10px' }}>显示方式</p>
                    {ShowType}
                </>
            }
        </div>
        <div className={styles.leftBottom} style={{filter: imageUrl? 'none' : 'grayscale(100%)'}}>
            <Button
                className={styles.btn}
                loading={handleLoading}
                onClick={handClick}
                disabled={!imageUrl}
                type="primary">
                修改尺寸
                <img src={require('@assets/images/arcbean3.png')} />
                <span className={styles.beanNum}>5</span>
            </Button>
        </div>
    </div>
})

export default ResizePageLeft